import { Injectable } from '@angular/core';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { webhookCallSchema } from '@shared/ragai.schemas';
import { z } from 'zod';
import { BotService } from './bot.service';
import { EventManagerService } from './event-manager/event-manager.service';
/** Ruft konfigurierte Webhooks von Skills auf (`RAGAI.WEBHOOK`). */
/**
 * Ruft konfigurierte Webhooks von Skills auf (`RAGAI.WEBHOOK`).
 * @remarks
 * Dünner Wrapper um `BotService.callWebhook()`: Die eigentliche Webhook-URL/-Konfiguration steckt im Skill
 * selbst (Backend-seitig hinterlegt, nicht hier im Client) - der Skill wird nur über seine `skillId` referenziert.
 * Wird u. a. von `RAGAI.MAIL.webhook()` genutzt, um E-Mail-Inhalte an externe Systeme weiterzuleiten.
 */
@Injectable({
  providedIn: 'root'
})
export class WebhookManagerService {
  constructor(
    private botService: BotService,
    private botIdService: BotidService,
    private eventManager: EventManagerService
  ) {
  }

  /**
   * Ruft den konfigurierten Webhook eines Skills auf.
   * @param skillId ID des Skills, oder ein Objekt gemäß `webhookCallSchema`.
   * @param request Zusätzliche Daten, die an den Webhook gesendet werden.
   * @returns Die Antwort des Webhooks.
   */
  public async call(skillId: string | z.input<typeof webhookCallSchema>, request?: unknown) {
    const parsed = webhookCallSchema.safeParse(skillId);
    if (parsed.success && typeof skillId === 'object') {
      request = parsed.data.request ?? request;
      skillId = parsed.data.skillId;
    }
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.WEBHOOK.CALL.request', { skillId, request });
    const result = await this.botService.callWebhook(this.botIdService.getBotId(), skillId as string, request);
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.WEBHOOK.CALL.result', { skillId, request, result });
    return result;
  }
}
